import LengthLimitedTextField from "../../../common/components/LengthLimitedTextField"
import {
  stripEmbeddedEmailSignature,
  stripEmptyEditorPlaceholder,
  stripTemplateSignaturePreview,
} from "../components/emailSignatureUtils"

export function getEmailEditorHTML(editorRef) {
  return stripEmptyEditorPlaceholder(
    stripEmbeddedEmailSignature(
      stripTemplateSignaturePreview(editorRef.current.getContent())
    )
  )
}

export function SubjectField({ subject, setSubject }) {
  return (
    <LengthLimitedTextField
      label="Subject"
      value={subject}
      setValue={setSubject}
      maxLength={988}
      required
    />
  )
}
